import script from "./ProductListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductListPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__